<script lang="ts" setup>
import { app } from '@/composition/app'
import { GroupState } from '@/composition/groups'
import { DEFAULT_GROUP_COVER_IMAGE, DEFAULT_GROUP_LOGO } from '@/helper/const'
import { computed, inject, ref } from 'vue'

import { useRoute } from 'vue-router'

// Import useStickyHeader from a composable function
import { replaceBucketUrlWithCdnUrl } from '@/helper/ImageUpload.helper'
import { useStickyHeader } from '@/util/stickyHeader'

// Get showStickyHeader from inject
const showStickyHeader = inject('showStickyHeader') as { value: boolean }
const hamburgerIcon = ref<HTMLElement | null>(null)
const chatIcon = ref<HTMLElement | null>(null)

// Call the composable to handle intersection observation
useStickyHeader(showStickyHeader, hamburgerIcon)
useStickyHeader(showStickyHeader, chatIcon)

const props = defineProps({
  user: Object,
})
const route = useRoute()

const coverUrl = computed(() => {
  return route.params.userSlug
    ? replaceBucketUrlWithCdnUrl(props.user?.profileCover) ||
        DEFAULT_GROUP_COVER_IMAGE
    : replaceBucketUrlWithCdnUrl(GroupState.state.groupData.branding?.cover) ||
        DEFAULT_GROUP_COVER_IMAGE
})

const groupLogo = computed(() => {
  return GroupState.state.groupData.branding?.logo
    ? replaceBucketUrlWithCdnUrl(GroupState.state.groupData.branding?.logo)
    : DEFAULT_GROUP_LOGO
})
</script>
<template>
  <div class="w-full">
    <div
      id="info-container"
      class="info-sidebar-scrollbar overflow-hidden overflow-y-hidden bg-communities-background"
      :class="[
        !app.state.isMobile
          ? 'rounded-xl border border-solid border-communities-border'
          : 'mt-[46px]',
        route.name === 'private-group' && app.state.isMobile
          ? 'border-b-0'
          : '',
      ]"
    >
      <div class="relative w-full">
        <img
          id="cover-image"
          alt="Group Cover"
          :src="coverUrl || DEFAULT_GROUP_COVER_IMAGE"
          class="h-full w-full object-cover"
          :class="
            !app.state.isMobile ? 'max-h-[219px] rounded-t-xl' : 'max-h-[400px]'
          "
        />

        <img
          v-if="app.state.isMobile"
          :src="groupLogo"
          alt="Group Logo"
          class="absolute bottom-[-27px] left-4 z-10 h-[60px] w-[60px] rounded-full border-4 border-white object-cover"
        />
        <!-- side-menu button for mobile screen -->
      </div>
      <div
        v-if="!app.state.isMobile"
        class="relative mb-4 mt-[1rem] px-4 2xl:mt-[7.25rem]"
      >
        <slot name="info-details" />
      </div>
      <div v-else class="relative mb-3 mt-8 bg-communities-background px-3">
        <slot name="info-details" />
      </div>
    </div>
  </div>
</template>
<style scoped>
.info-logo {
  top: 80px;
  left: 100px;
}
.info-sidebar-scrollbar {
  scrollbar-width: thin;
}

.info-sidebar-scrollbar::-webkit-scrollbar {
  background-color: transparent;
  width: 0px;
}

.info-sidebar-scrollbar::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 2px;
}
.info-sidebar-scrollbar:hover::-webkit-scrollbar-thumb {
  background-color: var(--fill);
  border-radius: 2px;
}
</style>
